export default "__VITE_ASSET__BqUh3cgZ__"